import { TableCell } from "@mui/material"
import decamelize from "decamelize"

export function FieldHeader({ item }) {
    return <TableCell>{item?.label || decamelize(item.field).titleize()}</TableCell>
}
